<template>
  <div class="privacy">
    <div v-if="false">〜お申し込みの前にご確認ください。〜</div>
    <h2 class="preformTitle">個人情報の保護について</h2>
    <section class="group">
      <div>お知らせいただく個人に関する情報は，小社の個人情報保護方針にもとづき以下のように管理させていただきます。</div>
      <ul class="preform">
        <li>第一学習社 個人情報保護方針 <a href="http://www.daiichi-g.co.jp/privacy/index.html" target="_blank">http://www.daiichi-g.co.jp/privacy/index.html</a></li>
        <li>第一学習社 個人情報保護管理者 総務部部長（Tel 082-234-7757）</li>
      </ul>
    </section>
    <section class="preformBody">
      <dl>
        <dt>個人情報の送信方法</dt>
        <dd>
          <div>当ホームページの各種フォームより入力された情報はSSL（暗号化技術）を使用して送信されます。</div>
        </dd>
        <dt>個人情報の利用目的</dt>
        <dd>
          <div>お知らせいただいた個人に関する情報は，以下の目的で利用します。</div>
          <ol>
            <li>新課程オンラインセミナーの準備</li>
            <li>受付，ライセンス発送</li>
            <li>お申込内容に関する窓口からの確認</li>
            <li>お問い合わせに対するお返事</li>
            <li>弊社からのお知らせ、ご案内など</li>
          </ol>
        </dd>
        <dt>個人情報の管理</dt>
        <dd>
          <div>個人情報は，法令に基づく場合および本人の同意がある場合を除き第三者へ開示することはありません。</div>
        </dd>
        <dt>個人情報の提供の任意性</dt>
        <dd>
          <div>入力フォームの情報提供は任意ですが，※のついている項目について入力が無い場合は資料請求やご注文ができません。</div>
        </dd>
        <dt>個人情報の委託</dt>
        <dd>
          <div>お知らせいただいた個人情報の取り扱いの全部または一部を委託することはありません。</div>
        </dd>
        <dt>本人が容易に知覚できない方法による個人情報の取得</dt>
        <dd>
          <div>クッキーやウェブビーコン等を用いるなどして，本人が容易に知覚できない方法による個人情報の取得は行っておりません。</div>
        </dd>
        <dt>保有個人データの利用目的の通知，開示，訂正，追加，削除，利用停止等</dt>
        <dd>
          <div>当ホームページよりお知らせいただいた個人情報の利用目的の通知，開示，内容の訂正，追加又は削除，利用の停止，消去又は
            第三者への提供の停止についてご請求いただく場合は，
            ［<a href="http://www.daiichi-g.co.jp/privacy/detail.html#mado2" target="_blank">保有個人データの開示等の請求窓口</a>］
            へお願いします。</div>
        </dd>
      </dl>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.preformTitle {
  background-color: #1564AC;
  color: white;
  padding: 10px;
}

.preformBody {
  padding: 20px;
  border: 1px solid gray;
  dl {
    dt {
      font-size: 1.2em;
      &:before {
        content: "【"
      }
      &:after {
        content: "】"
      }
    }
    dd {
      margin-left: 2em;
      text-indent: 1em;
    }
  }
}

ul.preform {
  list-style-type: none;
}
</style>

<script>
export default {
  name: 'Privacy'
}
</script>
